<nav class="navbar navbar-expand-lg navbar-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img src="assets/images/logo.png" alt="Logo" class="logo">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" *ngIf="studEmpPerformanceDashboard">
          <a class="nav-link" id="dashboardPerformanceLink" (click)="callDispute(33)"><i class="fa fa-bar-chart"
              aria-hidden="true"></i>Performance Dashboard</a>
        </li>
        <li class="nav-item" *ngIf="studEmpDashboard">
          <a class="nav-link" id="dashboardLink" (click)="callDispute(29)"><i class="fa fa-bar-chart"
              aria-hidden="true"></i> Dashboard</a>
        </li>
        <li class="nav-item dropdown" *ngIf="studEmpMasters">
          <a class="nav-link dropdown-toggle" id="masterDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-users" aria-hidden="true"></i> Masters
          </a>
          <div class="dropdown-menu" aria-labelledby="masterDropdown">
            <a class="dropdown-item" (click)="callDispute(4)" id="docMasterLink">Document Master</a>
            <a class="dropdown-item" (click)="callDispute(7)" id="streamMasterLink">Stream Master</a>
            <a class="dropdown-item" (click)="callDispute(13)" id="collegeMasterLink">College Master</a>
            <a class="dropdown-item" (click)="callDispute(10)" id="priceMasterLink">Price Master</a>
            <a class="dropdown-item" (click)="callDispute(16)" id="userMasterLink">User Master</a>
            <a class="dropdown-item" (click)="callDispute(20)" id="priceMasterLink">Branch Master</a>
            <a class="dropdown-item" (click)="callDispute(21)" id="semesterMasterLink">Semester Master</a>
            <a class="dropdown-item" (click)="callDispute(35)" id="passingYearLink">Passing Year Master</a>
          </div>
        </li>
        <li class="nav-item" *ngIf="studEmpMasters">
          <a class="nav-link" id="dashboardLink" (click)="callDispute(39)"><i class="fa fa-bar-chart"
              aria-hidden="true"></i> MIS Report</a>
        </li> 
        <li class="nav-item" *ngIf="studEmpUploadDocuments">
          <a class="nav-link" (click)="callDispute(30)"><i class="fa fa-upload" aria-hidden="true"
              id="UploadDocumentsLink"></i> Upload Documents- Excel</a>
        </li>
        <li class="nav-item" *ngIf="studEmpSearchDocuments">
          <a class="nav-link" (click)="callDispute(31)"><i class="fa fa-search" aria-hidden="true"
              id="UploadDocumentsLink"></i> Search and Edit Documents</a>
        </li>
        <li class="nav-item" *ngIf="RecordEntry">
          <a class="nav-link" (click)="callDispute(38)"><i class="fa fa-upload" aria-hidden="true"
              id="RecordEntryLink"></i> Upload Documents</a>
        </li>
        <li class="nav-item" *ngIf="studEmpSearchOnlyDocuments">
          <a class="nav-link" (click)="callDispute(34)"><i class="fa fa-search" aria-hidden="true"
              id="studEmpSearchOnlyDocumentsLink"></i> Search Documents</a>
        </li>
        <li class="nav-item" *ngIf="universityDashboard">
          <a class="nav-link" (click)="callDispute(40)"><i class="fa fa-bar-chart" aria-hidden="true"
              id="universityDashboardLink"></i> Dashboard</a>
        </li>
        <li class="nav-item" *ngIf="universityDashboard">
          <a class="nav-link" (click)="callDispute(26)"><i class="fa fa-wpforms" aria-hidden="true"
              id="universityDocVerificationLink"></i> Document Verification</a>
        </li>
        <li class="nav-item" *ngIf="verifierDocVerifier">
          <a class="nav-link" (click)="callDispute(27)"><i class="fa fa-wpforms" aria-hidden="true"
              id="verifierDocVerificationLink"></i> Document Verification</a>
        </li>
        <li class="nav-item" *ngIf="verifierDocVerifier">
          <a class="nav-link" (click)="callDispute(41)"><i class="fa fa-wpforms" aria-hidden="true"
              id="verifierDocVerificationLink"></i> Rejected Request</a>
        </li>
        <li class="nav-item dropdown" *ngIf="studEmpRequest">
          <a class="nav-link dropdown-toggle active" id="requestDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-wpforms" aria-hidden="true"></i> Request
          </a>
          <div class="dropdown-menu" aria-labelledby="requestDropdown">
            <a class="dropdown-item active" (click)="callDispute(1)" id="docverifyLink">Document Verification</a>
            <a class="dropdown-item" (click)="callDispute(3)" id="offlineVerifyLink">Offline Document Verification</a>
          </div>
        </li>
        <li class="nav-item" *ngIf="studEmpDisputes">
          <a class="nav-link" (click)="callDispute(1)" id="disputesLink"><i class="fa fa-exclamation-triangle"
              aria-hidden="true"></i> Disputes</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="profileDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{UserName}}
            <!-- <span class="login-thumbnail" style="font-weight:bold">{{UserNameFirstLetter| uppercase}}</span> -->
            <span> <img src="assets/images/user.png" alt="Logo" (click)="gotoHomePage()" class="userlogo"></span>
          </a>
          <div class="dropdown-menu" aria-labelledby="profileDropdown">
            <a class="dropdown-item" (click)="logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>